import React from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

function SideBySide({ data }) {
  const {
    leftItemTitle,
    leftItemText,
    leftButtonText,
    leftPdf,
    rightItemTitle,
    rightItemText,
    rightButtonText,
    rightPdf,
  } = data
  return (
    <section className="container-fluid resources-backorders-section">
      <div className="row d-flex justify-content-lg-center">
        <div className="col-sm-5 col-lg-5 mt-3 ml-auto">
          <div className="resources-backorders-left-side">
            <div className="resources-backorders-title">{leftItemTitle}</div>
            <div className="resources-backorders-text">{leftItemText}</div>
            <a
              className="btn btn-primary mt-1"
              href={leftPdf.fields.file.url}
              rel="noopener noreferrer"
              target="_blank"
            >
              <i className="mdi mdi-cloud-download-outline" /> {leftButtonText}
            </a>
          </div>
        </div>
        <div className="col-sm-5 col-lg-5 mt-3">
          <div className="resources-backorders-right-side">
            <div className="resources-backorders-title">{rightItemTitle}</div>
            <div className="resources-backorders-text">{rightItemText}</div>
            <a
              className="btn btn-primary mt-1"
              href={rightPdf.fields.file.url}
              rel="noopener noreferrer"
              target="_blank"
            >
              <i className="mdi mdi-cloud-download-outline" /> {rightButtonText}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SideBySide
